export default __webpack_public_path__ + "static/media/virtual.ee7215b2.svg";